import { firefuncs } from "config/firebase";
import { httpsCallable } from "firebase/functions";

const removeFromWaitlist = (gameId: string, userId: string): void => {
  const removeFromWait = httpsCallable(firefuncs, "removeFromWaitlist");

  removeFromWait({
    gameId,
    id: userId,
  })
    .then((res) => {
      console.log((res.data as any)?.message);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default {
  removeFromWaitlist,
};
